import { Flex } from '@common/components/Flex';
import { ErrorIcon } from '@common/components/error-icon';

import './error-message.styles.scss';

export const ErrorMessage = (props) => {
	const { children } = props;

	return (
		<Flex className="ErrorMessage">
			<ErrorIcon margin="0 8px 0 0" />
			<div className="ErrorMessage__children">{children}</div>
		</Flex>
	);
};